module.exports = __webpack_public_path__ + "f04a94bacebfd3ac7c085db40e75dd61.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-Regular.woff
// module id = 424
// module chunks = 0